import { render, staticRenderFns } from "./cowinfo.vue?vue&type=template&id=78825c0d&scoped=true&"
import script from "./cowinfo.vue?vue&type=script&lang=js&"
export * from "./cowinfo.vue?vue&type=script&lang=js&"
import style0 from "./cowinfo.vue?vue&type=style&index=0&id=78825c0d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78825c0d",
  null
  
)

export default component.exports